import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/long-insure/renewal.png'
import _imports_1 from '../assets/long-insure/add-btn.png'
import _imports_2 from '../assets/long-insure/reduce-btn.png'
import _imports_3 from '../assets/chart/chart-line-green.png'
import _imports_4 from '@/assets/chart/chart-line-blue.png'
import _imports_5 from '../assets/chart/chart-bar-blue.png'
import _imports_6 from '../assets/long-insure/add-safe.png'
import _imports_7 from '../assets/long-insure/reduce-safe.png'
import _imports_8 from '../assets/long-insure/stop-safe.png'


const _hoisted_1 = { class: "header block" }
const _hoisted_2 = { class: "header-left" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "header-left-info" }
const _hoisted_5 = { class: "left-info-title" }
const _hoisted_6 = { class: "left-info-name" }
const _hoisted_7 = { class: "left-info-date" }
const _hoisted_8 = { class: "left-info-icon" }
const _hoisted_9 = {
  key: 0,
  class: "info-title-tips"
}
const _hoisted_10 = { class: "header-right flex flex-ai-c flex-wrap" }
const _hoisted_11 = { class: "container-info-box" }
const _hoisted_12 = { class: "row container-row-box" }
const _hoisted_13 = { class: "block-active-list" }
const _hoisted_14 = { class: "block block-active" }
const _hoisted_15 = { class: "block-content" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "balance" }
const _hoisted_19 = { class: "number" }
const _hoisted_20 = { class: "block block-active" }
const _hoisted_21 = { class: "block-content" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "number" }
const _hoisted_25 = { class: "block block-active" }
const _hoisted_26 = { class: "block-content" }
const _hoisted_27 = { class: "row" }
const _hoisted_28 = { class: "" }
const _hoisted_29 = { class: "number" }
const _hoisted_30 = { class: "container-list" }
const _hoisted_31 = { class: "block premium-trend" }
const _hoisted_32 = { class: "block-header" }
const _hoisted_33 = { class: "block-search" }
const _hoisted_34 = { style: {"margin-left":"6px"} }
const _hoisted_35 = {
  key: 0,
  class: "row-replace"
}
const _hoisted_36 = { class: "replace-text" }
const _hoisted_37 = { class: "replace-text" }
const _hoisted_38 = { class: "block-content" }
const _hoisted_39 = { class: "table" }
const _hoisted_40 = {
  key: 0,
  class: "operation-type-img",
  src: _imports_6
}
const _hoisted_41 = {
  key: 1,
  class: "operation-type-img",
  src: _imports_7
}
const _hoisted_42 = {
  key: 2,
  class: "operation-type-img",
  src: _imports_8
}
const _hoisted_43 = { class: "decorate-box" }
const _hoisted_44 = {
  key: 0,
  class: "decorate",
  style: {background:'#00D679'}
}
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { key: 3 }
const _hoisted_47 = { class: "operation-box" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = {
  key: 0,
  class: "point"
}
const _hoisted_50 = ["disabled", "onClick"]
const _hoisted_51 = { class: "block" }
const _hoisted_52 = { class: "block-content" }
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "block plan" }
const _hoisted_55 = { class: "block-header" }
const _hoisted_56 = { class: "staff-list" }
const _hoisted_57 = { class: "dressing-by-screening" }
const _hoisted_58 = { class: "table table-naem" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }
const _hoisted_62 = {
  key: 0,
  class: "rovalsState"
}
const _hoisted_63 = {
  key: 1,
  class: "rovalsState"
}
const _hoisted_64 = {
  key: 2,
  class: "rovalsState"
}
const _hoisted_65 = { class: "flexend" }
const _hoisted_66 = {
  key: 0,
  class: "plan-list-notice"
}
const _hoisted_67 = { class: "notice-box" }
const _hoisted_68 = { class: "notice-box-desc" }
const _hoisted_69 = { class: "notice-box-desc-content" }
const _hoisted_70 = { class: "desc-content-box" }
const _hoisted_71 = { class: "notice-box-footer" }
const _hoisted_72 = {
  key: 0,
  class: "footer-button-tips"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Document = _resolveComponent("Document")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_export_button = _resolveComponent("export-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_tab_capsule = _resolveComponent("tab-capsule")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _ctx.tioInfo.logo,
          alt: "",
          class: "portrait"
        }, null, 8, _hoisted_3),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.tioInfo.planName), 1),
            _createElementVNode("div", {
              class: _normalizeClass(['info-title-status',!_ctx.tioInfo.enable ? 'title-status-no' : 'title-status-ok'])
            }, _toDisplayString(!_ctx.tioInfo.enable ? '已禁用' : '已启用'), 3),
            (_ctx.planTermsData.id != -1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "info-plan-list",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onShowPlan && _ctx.onShowPlan(...args)))
                }, [
                  _cache[16] || (_cache[16] = _createTextVNode(" 商品条款 ")),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Document)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.tioInfo.planStartTime) + " 至 " + _toDisplayString(_ctx.tioInfo.planEndTime || '暂无到期时间'), 1),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.tioInfo.type === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 月单 "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tioInfo.dangerLevel, (k) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(['info-title-status',`tag-${k}`]),
                key: k
              }, _toDisplayString(k === 3 ? '1-3' : k) + "类 ", 3))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.canInsureRenewal)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass([{'disabled': !_ctx.tioInfo.enable}, "btn btn-white-blue right-btn"]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.tioInfo.enable && _ctx.onRenew()))
            }, _cache[17] || (_cache[17] = [
              _createElementVNode("img", {
                class: "header-right-img",
                src: _imports_0
              }, null, -1),
              _createTextVNode(" 续保 ")
            ]), 2))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass([{'disabled': !_ctx.tioInfo.enable}, "btn btn-green right-btn"]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.tioInfo.enable && _ctx.onInsureAdd()))
        }, _cache[18] || (_cache[18] = [
          _createElementVNode("img", {
            class: "header-right-img",
            src: _imports_1
          }, null, -1),
          _createTextVNode(" 加保 ")
        ]), 2),
        _createElementVNode("button", {
          class: "btn btn-red right-btn",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onInsureSubtract && _ctx.onInsureSubtract(...args)))
        }, _cache[19] || (_cache[19] = [
          _createElementVNode("img", {
            class: "header-right-img",
            src: _imports_2
          }, null, -1),
          _createTextVNode(" 减保 ")
        ])),
        _createVNode(_component_export_button, {
          class: "mg-l-20",
          onExport: _ctx.handleExport
        }, null, 8, ["onExport"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "block-title" }, "客户管理", -1)),
        _createElementVNode("div", null, [
          _createVNode(_component_el_date_picker, {
            modelValue: _ctx.customerDate,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerDate) = $event)),
            type: "month",
            placeholder: "选择日期",
            onChange: _ctx.getInsureDetailInfo,
            format: "YYYY/MM",
            "value-format": "YYYY-MM"
          }, null, 8, ["modelValue", "onChange"])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "block-header" }, [
            _createElementVNode("div", { class: "block-title" }, "总人数"),
            _createElementVNode("div", { class: "block-more" })
          ], -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "key" }, "人数", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.tioInfo.totalCount), 1)
                ])
              ]),
              _cache[22] || (_cache[22] = _createElementVNode("img", {
                class: "img-chart",
                src: _imports_3
              }, null, -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _cache[26] || (_cache[26] = _createElementVNode("div", { class: "block-header" }, [
            _createElementVNode("div", { class: "block-title" }, "当前在保人数"),
            _createElementVNode("div", { class: "block-more" })
          ], -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[24] || (_cache[24] = _createElementVNode("div", { class: "key" }, "人数", -1)),
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.tioInfo.ensureCount), 1)
              ]),
              _cache[25] || (_cache[25] = _createElementVNode("img", {
                class: "img-chart",
                src: _imports_4
              }, null, -1))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[30] || (_cache[30] = _createElementVNode("div", { class: "block-header" }, [
            _createElementVNode("div", { class: "block-title" }, "本月保费"),
            _createElementVNode("div", { class: "block-more" })
          ], -1)),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "key" }, "金额（元）", -1)),
                _cache[28] || (_cache[28] = _createTextVNode(" ¥")),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.tioInfo.fee), 1)
              ]),
              _cache[29] || (_cache[29] = _createElementVNode("img", {
                class: "img-chart",
                src: _imports_5
              }, null, -1))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _cache[31] || (_cache[31] = _createElementVNode("div", { class: "block-title" }, "操作记录", -1)),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", null, [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.countDate,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.countDate) = $event)),
                type: "date",
                placeholder: "选择日期",
                onChange: _ctx.getInsureDetailAdditionList,
                format: "YYYY/MM/DD",
                "value-format": "YYYY-MM-DD"
              }, null, 8, ["modelValue", "onChange"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchName,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchName) = $event)),
                placeholder: "请输入录入人",
                onBlur: _ctx.getInsureDetailAdditionList
              }, null, 8, ["modelValue", "onBlur"])
            ])
          ])
        ]),
        (_ctx.showReplaceCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("span", _hoisted_36, "可替换:" + _toDisplayString(_ctx.replaceCountInfo.canReplaceCount ? _ctx.replaceCountInfo.canReplaceCount : 0), 1),
              _createElementVNode("span", _hoisted_37, "已替换:" + _toDisplayString(_ctx.replaceCountInfo.alreadyReplaced ? _ctx.replaceCountInfo.alreadyReplaced : 0), 1),
              _createElementVNode("span", null, "总替换:" + _toDisplayString(_ctx.replaceCountInfo.totalReplaceQuota ? _ctx.replaceCountInfo.totalReplaceQuota: 0), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_el_table, {
              data: _ctx.countList,
              style: {"width":"100%"},
              "header-row-style": { color: '#202536' },
              "row-style": { color: '#5E617D' },
              "header-cell-style": { background: '#F7F8FC' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, { label: "操作类型" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                    'operation-type-box',
                    scope.row.isAllowRevoke == 1 || scope.row.operationType == 2
                        ? 'operation-type-box-active'
                        : ''
                    ])
                    }, [
                      (scope.row.operationType == 0)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_40))
                        : _createCommentVNode("", true),
                      (scope.row.operationType == 1 || scope.row.operationType == 2)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_41))
                        : _createCommentVNode("", true),
                      (scope.row.operationType == 11)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_42))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(scope.row.operationType == 1 ? '减保' : scope.row.operationType == 2 ? '撤保' : scope.row.operationType == 11 ? '断保' : '加保'), 1)
                    ], 2)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  label: "人数",
                  prop: "total"
                }),
                _createVNode(_component_el_table_column, {
                  label: "生效时间",
                  prop: "insureStartDate"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "createTime",
                  label: "录入时间"
                }),
                _createVNode(_component_el_table_column, {
                  label: "录入人",
                  prop: "managerName"
                }),
                _createVNode(_component_el_table_column, { label: "状态" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_43, [
                      (scope.row.operationType==11)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "decorate",
                            style: _normalizeStyle({
                                      background:
                                          scope.row.revokeType=='0'
                                              ? scope.row.isSuccess
                                              ? '#00D679'
                                              : '#DC1515'
                                              : '#FF7642'
                                  })
                          }, null, 4)),
                      (scope.row.operationType==11)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_45, "成功"))
                        : (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(scope.row.revokeType=='0' ? scope.row.isSuccess ? '成功' : '失败': scope.row.revokeType=='1'?'撤销':'--'), 1))
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, { label: "操作" }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("p", {
                        style: {"color":"#1989FA"},
                        class: "point",
                        onClick: ($event: any) => (
                        _ctx.getInsureDetailAdditionExport(
                            scope.row.id
                        )
                        )
                      }, " 导出名单 ", 8, _hoisted_48),
                      (_ctx.tioInfo.insurePlanType !== 2 && scope.row.canRevoke == 1 && scope.row.managerId != 1)
                        ? (_openBlock(), _createElementBlock("text", _hoisted_49, "/ "))
                        : _createCommentVNode("", true),
                      (_ctx.tioInfo.insurePlanType !== 2 && scope.row.canRevoke == 1 && scope.row.managerId != 1)
                        ? (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            style: {"color":"#1989FA"},
                            disabled: _ctx.tioInfo.insurePlanType !== 2,
                            class: "point",
                            onClick: ($event: any) => (_ctx.onLongTermRevoke(scope.row.id))
                          }, " 撤回", 8, _hoisted_50))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_el_pagination, {
              class: "pagination",
              currentPage: _ctx.countPageNum,
              "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.countPageNum) = $event)),
              "page-size": _ctx.countPageSize,
              "onUpdate:pageSize": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.countPageSize) = $event)),
              "page-sizes": [10, 30, 50, 100],
              layout: "total, prev, pager, next, jumper",
              total: _ctx.countTotal,
              onSizeChange: _ctx.getInsureDetailAdditionList,
              onCurrentChange: _ctx.getInsureDetailAdditionList
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_51, [
        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "block-header" }, [
          _createElementVNode("div", { class: "block-title" }, "人员统计")
        ], -1)),
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _cache[32] || (_cache[32] = _createElementVNode("div", null, null, -1)),
            _createVNode(_component_tab_capsule, {
              class: "tab-cap",
              active: _ctx.statisticsTab,
              list: ['工种', '派遣单位'],
              onTabchange: _ctx.onStatisticsTab
            }, null, 8, ["active", "onTabchange"])
          ]),
          _cache[33] || (_cache[33] = _createElementVNode("div", { id: "echarts" }, null, -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_54, [
      _createElementVNode("div", _hoisted_55, [
        _cache[35] || (_cache[35] = _createElementVNode("div", { class: "block-title" }, "人员名单", -1)),
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.payType,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.payType) = $event)),
              filterable: "",
              placeholder: "筛选状态",
              class: "screen-i",
              onChange: _ctx.handleCurrentChange
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payTypeList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item,
                    value: item,
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.personneDate,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.personneDate) = $event)),
              type: "date",
              placeholder: "选择日期",
              onChange: _ctx.getInsureDetailPersonnelList,
              format: "YYYY/MM/DD",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue", "onChange"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_58, [
        _createVNode(_component_el_table, {
          data: _ctx.personnelList,
          style: {"width":"100%"},
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          "header-cell-style": { background: '#F7F8FC' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "userName",
              label: "姓名"
            }),
            _createVNode(_component_el_table_column, { label: "身份证号" }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", {
                  style: {"cursor":"pointer"},
                  onClick: ()=>{scope.row.showIdCard = !scope.row.showIdCard}
                }, [
                  ( scope.row.showIdCard)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(scope.row.idCardNo), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(scope.row.encryptionIdCardNo), 1))
                ], 8, _hoisted_59)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "派遣单位",
              prop: "serveCompanyName"
            }),
            _createVNode(_component_el_table_column, {
              width: "240px",
              prop: "createTime",
              label: "录入时间"
            }),
            _createVNode(_component_el_table_column, {
              label: "所属工种",
              prop: "occupationName"
            }),
            _createVNode(_component_el_table_column, { label: "在保时间" }, {
              default: _withCtx((scoped) => [
                _createElementVNode("span", null, _toDisplayString(scoped.row.insureStartTime) + " ~ " + _toDisplayString(scoped.row.insureEndTime ? scoped.row.insureEndTime : '长期有效'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "状态",
              class: "dot",
              "is-dot": ""
            }, {
              default: _withCtx((scoped) => [
                (scoped.row.policyStatus == '0')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_62, _cache[36] || (_cache[36] = [
                      _createElementVNode("em", { class: "sub" }, null, -1),
                      _createTextVNode("待生效 ")
                    ])))
                  : _createCommentVNode("", true),
                (scoped.row.policyStatus == '1')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_63, _cache[37] || (_cache[37] = [
                      _createElementVNode("em", { class: "adopt" }, null, -1),
                      _createTextVNode("保障中 ")
                    ])))
                  : _createCommentVNode("", true),
                (scoped.row.policyStatus == '2')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, _cache[38] || (_cache[38] = [
                      _createElementVNode("em", { class: "stay" }, null, -1),
                      _createTextVNode("不在保 ")
                    ])))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.personnelPageNum,
          "onUpdate:currentPage": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.personnelPageNum) = $event)),
          "page-size": _ctx.personnelPageSize,
          "onUpdate:pageSize": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.personnelPageSize) = $event)),
          layout: "total, prev, pager, next, jumper",
          total: _ctx.personnelTotal,
          onSizeChange: _ctx.getInsureDetailPersonnelList,
          onCurrentChange: _ctx.getInsureDetailPersonnelList
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.isUp,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isUp) = $event)),
      width: "450px",
      title: "导出账单",
      center: ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _createVNode(_component_el_button, {
            type: "",
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => _cache[39] || (_cache[39] = [
              _createTextVNode("取消")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onSure
          }, {
            default: _withCtx(() => _cache[40] || (_cache[40] = [
              _createTextVNode("导出")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            ref: "ruleFormRef",
            "label-width": "85px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "账单月份" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    onChange: _ctx.onChangeDate,
                    modelValue: _ctx.form.filterMonth,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.filterMonth) = $event)),
                    type: "month",
                    style: {"width":"250px"},
                    format: "YYYY/MM",
                    size: "small",
                    "value-format": "YYYY-MM",
                    clearable: false
                  }, null, 8, ["onChange", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _cache[41] || (_cache[41] = _createElementVNode("div", { class: "notice-box-header" }, null, -1)),
            _createElementVNode("div", _hoisted_68, [
              _createElementVNode("div", _hoisted_69, [
                _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.planTermsData.dictValue), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              (_ctx.countDownTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, "重要信息，请耐心阅读(" + _toDisplayString(_ctx.countdown) + ")秒", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(['notice-box-footer-button' , _ctx.countDownTime? 'footer-button-no' :'']),
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.onCancelPlanNotice && _ctx.onCancelPlanNotice(...args)))
              }, "我已阅读，并了解", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}